















































































import store from '@/store'
import ApiClient from '@/js/api.js'
import Global from '@/js/global.js'
import Pankuzu from '@/views/molecules/Pankuzu.vue'
import Title from '@/views/atoms/Title.vue'
import NormalButton from '@/views/atoms/NormalButton.vue'
import YellowButton from '@/views/atoms/YellowButton.vue'
import BackButton from '@/views/atoms/BackButton.vue'
import DeleteButton from '@/views/atoms/DeleteButton.vue'
import ManageSubTitle from '@/views/atoms/ManageSubTitle.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import ManageRow from '@/views/organisms/ManageRow.vue'
import ManageBase from '@/views/organisms/ManageBase.vue'
import ManageTemplate from '@/views/templates/ManageTemplate.vue'
import ConfirmPopup from '@/views/molecules/ConfirmPopup.vue'
import CartButtonArea from '@/views/molecules/CartButtonArea.vue'
import CartTemplate from '@/views/templates/CartTemplate.vue'

export default
  name: 'Cart'

  components: {
    Pankuzu
    Title
    NormalButton
    YellowButton
    BackButton
    DeleteButton
    ManageSubTitle
    ManageRow
    ManageBase
    ManageTemplate
    ConfirmPopup
    TextBox
    CartButtonArea
    CartTemplate
  }

  watch:
    $route: (to, from) ->
      console.log from

  data: () ->
    cartData:
      order_list: []
      plan_list: []
    isShowDeletePopup: false
    deleteID: 0

  created: () ->
    store.dispatch('initPostParam')
    @$emit('set_color', true)
    @_getDetail()

  computed: {
    total_price_tax: () ->
      total = 0
      for row in @cartData.order_list
        total += row.price * row.count
      for row in @cartData.plan_list
        total += row.price * row.count
      return total
  }

  methods: {
    go_next: (e) ->
      if await store.getters.isLogin
        @$router.push '/regi'
      else
        @$router.push '/login/cart'
    cart_delete: (row) ->
      param =
        id: row.id
      api = new ApiClient()
      data = await api.post('/member/cart/delete', true, param)
      store.dispatch('addCartNum', -row.count)
      @_getDetail()
    num_change: (row) ->
      param =
        id: row.index
        count: row.val
      api = new ApiClient()
      data = await api.post('/member/cart/save', true, param)
      if data.errors.length != 0
        alert data.errors.count[0]
      @_getDetail()
    go_shopping: (e) ->
      @$router.push '/'
    go_back: (e) ->
      if window.beforeUrl
        @$router.push window.beforeUrl.fullPath
      else
        @$router.push '/'
    comma: (price) ->
      Global.comma(price)
    _getDetail: () ->
      @cartData.order_list = []
      api = new ApiClient()
      data = await api.get('/member/cart/list')
      @cartData = data.list
      count = 0
      for k, r of @cartData
        for row in r
          count += parseInt(row.count, 10)
      store.dispatch('setCartNum', count)
  }
